
function cellDataMapper() {
    const mapper = {
        "requestedMaterialName": ({ row: { original } = {} }) => {
            return <button className="text-primary-500 text-left"> {original?.requestedMaterialName ?? '-'}</button>;
        },
        "externalId": ({ row: { original } = {} }) => {
            return <button className="text-primary-500 text-left"> {original?.externalId ?? '-'}</button>;
        },
        "changed": ({ row: { original } = {} }) => {
            const { requestedQty, confirmedQty } = original || {};
            if (isNaN(requestedQty) || isNaN(confirmedQty)) {
                return <>-</>
            }
            return <>{requestedQty - confirmedQty}</>
        }
    }

    return mapper;
}

function getMappedCellDataForOnlineItems(columns) {
    const mapper = cellDataMapper()

    const cols = columns.map((col) => {
        return {
            ...col,
            cellData: mapper[col.name_of_db_column]
        }
    });
    return cols
}

export {
    getMappedCellDataForOnlineItems
}
